import { userConstants } from './userConstants';
import { userService } from './userServices';

export const userActions = {
  list,
  invalidate,
  setPagination,
  load,
  save,
  setStatus,
  sendToken,
  checkToken,
};

function list() {
  return (dispatch, getState) => {
    const state = getState()

    // if (!state.acl_users.shouldReload) {
    //   return
    // }

    dispatch(request());

    userService.list(state.acl_users)
      .then(
        users => {
          dispatch(success(users));
        },
        error => {
          dispatch(failure(error.toString()));
        }
      );
  };

  function request() { return { type: userConstants.ACL_USER_LIST_REQUEST } }
  function success(users) { return { type: userConstants.ACL_USER_LIST_SUCCESS, users } }
  function failure(error) { return { type: userConstants.ACL_USER_LIST_FAILURE, error } }
}

function invalidate() {
  return (dispatch) => {
    dispatch(request());
  };

  function request() { return { type: userConstants.ACL_USER_LIST_CHANGED } }
}

function setPagination(pagination) {
  return (dispatch) => {
    dispatch(request(pagination));
  };

  function request(pagination) { return { type: userConstants.ACL_USER_LIST_PAGINATION, pagination } }
}

function setStatus(status) {
  return (dispatch) => {
    dispatch(request(status));
  };

  function request(status) { return { type: userConstants.ACL_USER_LIST_STATUS, status } }
}

function load(id) {
  return dispatch => {
    dispatch(request({ id }));

    userService.load(id)
      .then(
        user => {
          dispatch(success(user));
        },
        error => {
          dispatch(failure(error.toString()));
        }
      );
  };

  function request(id) { return { type: userConstants.ACL_USER_LOAD_REQUEST, id } }
  function success(user) { return { type: userConstants.ACL_USER_LOAD_SUCCESS, user } }
  function failure(error) { return { type: userConstants.ACL_USER_LOAD_FAILURE, error } }
}

function save(user, history, cb, scc) {
  return dispatch => {
    dispatch(request());

    const isNew = user.id === "";

    userService.save(user)
      .then(
        rt => {
          if (rt.error) {
            dispatch(failure(rt.message));
            if (typeof cb === 'function') cb(rt);
          } else {
            if (rt.id) {
              if (isNew) user.id = rt.id
              dispatch(success(user, isNew));
              if (typeof scc === 'function') scc();
              if (isNew) {
                history.replace(`/reload`); // hack to force reloading of component without reloading page
                history.replace("/acl/users/" + rt.id);
              }
            }
          }
        },
        error => {
          dispatch(failure(error.toString()));
          if (typeof cb === 'function') cb(error);
        }
      );
  };

  function request() { return { type: userConstants.ACL_USER_SAVE_REQUEST } }
  function success(user, isNew) { return { type: userConstants.ACL_USER_SAVE_SUCCESS, user, isNew } }
  function failure(error) {
    return { type: userConstants.ACL_USER_SAVE_FAILURE, error }
  }
}

function sendToken(userID, cb, scc) {
  return dispatch => {
    dispatch(request());
console.log('send token')
    userService.sendVerificationToken(userID)
      .then(
        response => {
          if (response.error) {
            dispatch(failure(response.message));
            if (typeof cb === 'function') cb(response);
          } else {
            dispatch(success(userID));
            if (typeof scc === 'function') scc();
          }
        },
        error => {
          dispatch(failure(error.toString()));
          if (typeof cb === 'function') cb(error);
        }
      );
  };

  function request() { return { type: userConstants.ACL_USER_SEND_TOKEN_REQUEST } }
  function success(userID) { return { type: userConstants.ACL_USER_SEND_TOKEN_SUCCESS, userID } }
  function failure(error) { return { type: userConstants.ACL_USER_SEND_TOKEN_FAILURE, error } }
}

function checkToken(userID, token, cb, scc) {
  return dispatch => {
    dispatch(request());

    userService.verifyEmailToken(userID, token)
      .then(
        response => {
          if (response.error) {
            dispatch(failure(response.message));
            if (typeof cb === 'function') cb(response);
          } else {
            dispatch(success(userID));
            if (typeof scc === 'function') scc();
          }
        },
        error => {
          dispatch(failure(error.toString()));
          if (typeof cb === 'function') cb(error);
        }
      );
  };

  function request() { return { type: userConstants.ACL_USER_CHECK_TOKEN_REQUEST } }
  function success(userID) { return { type: userConstants.ACL_USER_CHECK_TOKEN_SUCCESS, userID } }
  function failure(error) { return { type: userConstants.ACL_USER_CHECK_TOKEN_FAILURE, error } }
}
